import { fetchNewsList as fetchNewsListThunk, updateNewsStatus as updateNewsStatusThunk, createNews as createNewsThunk } from '../reducers/newsSlice';

// Action to fetch news list
export const fetchNewsList = (adminData) => {
  return async (dispatch) => {
    try {
      await dispatch(fetchNewsListThunk(adminData));
    } catch (error) {
      console.error('Error fetching news:', error);
    }
  };
};

// Action to update news status
export const updateNewsStatus = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(updateNewsStatusThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error updating news status:', error);
    }
  };
};

// Action to create news
export const createNews = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(createNewsThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error creating news:', error);
    }
  };
};
